import { Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import noContent from '../../assets/images/trustpage_no_content.svg';

interface INpsHeader {
  logo: string;
}

const SurveyHeader = ({ logo }: INpsHeader) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        backgroundColor: '#FFFFFF',
        borderBottom: `1px solid ${theme.palette.divider}`,
        pl: theme.spacing(2),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          {logo ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 'auto',
              }}
            >
              <Box
                component={'img'}
                sx={{
                  maxHeight: '126px',
                  maxWidth: '248px',
                  height: 'auto',
                  width: 'auto',
                  objectFit: 'contain',
                  m: theme.spacing(2),
                }}
                alt={`${logo} ${t('logo_label')}`}
                src={logo}
              />
            </Box>
          ) : (
            <Box
              component={'img'}
              sx={{
                maxHeight: '126px',
                maxWidth: '248px',
                height: 'auto',
                width: 'auto',
                objectFit: 'contain',
                m: theme.spacing(2),
              }}
              alt={`${noContent} ${t('logo_label')}`}
              src={noContent}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SurveyHeader;
